const CLIENT_PARAM_BUILDER_URL =
  'https://capi-automation.s3.us-east-2.amazonaws.com/public/client_js/capiParamBuilder/clientParamBuilder.bundle.js';
const CLIENT_PARAMS_HELPER_URL =
  'https://capi-automation.s3.us-east-2.amazonaws.com/public/client_js/clientParamsHelper/clientParamsHelper.bundle.js';

declare global {
  interface Window {
    clientParamBuilder?: {
      processAndCollectAllParams?: (url?: string) => Promise<unknown> | unknown;
    };
    clientParamsHelper?: {
      collectAndSetParams?: (consent: boolean) => Promise<unknown> | unknown;
    };
  }
}

const shouldLoadBuilder = (): boolean => {
  if (typeof document === 'undefined') return false;
  return Boolean(document.querySelector('meta[name="facebook-client-param-builder"]'));
};

const shouldLoadHelper = (): boolean => {
  if (typeof document === 'undefined') return false;
  return Boolean(document.querySelector('meta[name="facebook-client-params-helper"]'));
};

const loadScript = (src: string): Promise<void> => {
  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (document.querySelector<HTMLScriptElement>(`script[src="${src}"]`)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Gagal memuat skrip ${src}`));
    document.head.appendChild(script);
  });
};

let scriptsReady: Promise<void> | null = null;

const ensureScripts = (): Promise<void> => {
  if (!scriptsReady) {
    scriptsReady = (async () => {
      await loadScript(CLIENT_PARAM_BUILDER_URL);
      if (shouldLoadHelper()) {
        try {
          await loadScript(CLIENT_PARAMS_HELPER_URL);
        } catch (error) {
          console.warn('ClientParamsHelper gagal dimuat', error);
        }
      }
    })();
  }

  return scriptsReady;
};

export const runMetaParamBuilder = async (): Promise<void> => {
  if (typeof window === 'undefined' || !shouldLoadBuilder()) {
    return;
  }

  try {
    await ensureScripts();

    if (shouldLoadHelper()) {
      try {
        const helperResult = window.clientParamsHelper?.collectAndSetParams?.(true);
        if (helperResult instanceof Promise) {
          await helperResult;
        }
      } catch (error) {
        console.warn('ClientParamsHelper.collectAndSetParams error', error);
      }
    }

    const result = window.clientParamBuilder?.processAndCollectAllParams?.(window.location.href);
    if (result instanceof Promise) {
      await result;
    }
  } catch (error) {
    console.warn('clientParamBuilder.processAndCollectAllParams error', error);
  }
};
